import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { Donor } from '../../../interfaces/donor';
import { Recipient } from '../../../interfaces/recipient';

export interface PairComparisonDialogData {
  recipient: Recipient | null;
  donor: Donor | null;
}

@Component({
  selector: 'app-pair-comparison-dialog',
  imports: [CommonModule, MatDialogModule, MatButtonModule, MatIconModule],
  templateUrl: './pair-comparison-dialog.component.html',
  styleUrl: './pair-comparison-dialog.component.scss'
})
export class PairComparisonDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<PairComparisonDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: PairComparisonDialogData
  ) {}

  get donorHlaClassI(): string {
    if (!this.data.donor?.hla) return '';
    const tokens = this.data.donor.hla.split(' ');
    const drIndex = tokens.findIndex(t => t.startsWith('DR'));
    return drIndex === -1 ? this.data.donor.hla : tokens.slice(0, drIndex).join(' ');
  }

  get donorHlaClassII(): string {
    if (!this.data.donor?.hla) return '';
    const tokens = this.data.donor.hla.split(' ');
    const drIndex = tokens.findIndex(t => t.startsWith('DR'));
    return drIndex === -1 ? '' : tokens.slice(drIndex).join(' ');
  }

  get recipientAge(): number {
    return this.calcAge(this.data.recipient?.dob);
  }

  get donorAge(): number {
    return this.calcAge(this.data.donor?.dob);
  }

  private calcAge(dob: string | undefined): number {
    if (!dob) return 0;
    const birthDate = new Date(dob);
    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    const m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) age--;
    return age;
  }

  formatDate(dateStr: string | undefined): string {
    if (!dateStr) return '';
    const d = new Date(dateStr);
    return d.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' });
  }

  get showHla(): boolean {
    return !!(this.data.recipient?.abPhenotype || this.data.recipient?.drPhenotype || this.data.donor?.hla);
  }

  get donorLimitedToCenters(): string {
    return (this.data.donor?.limitedToCenter || []).map(c => c.name).join(', ');
  }

  close(): void {
    this.dialogRef.close();
  }
}
